const useProgramme = () => {
  const drawerMenu = [];

  return {
    drawerMenu,
  };
};

export default useProgramme;
